// Module
var code = "<div class=\"sticky-mini-header\"> <slot :isStickyMini=\"isStickyMini\"/> </div> ";
// Exports
export default code;